module.exports = __webpack_public_path__ + "resources/img/img_moai_main_func_jp.4b2901da455f22ef14975faeb5d3c809.png";